import { useCallback } from 'react';
import { setCartOpen } from 'appRedux/actions';
import { useAppDispatch } from 'appRedux/hooks';

export const useToggleCart = () => {
  const dispatch = useAppDispatch();

  const handleToggleCart = useCallback(
    (open: boolean) => dispatch(setCartOpen(open)),
    []
  );

  return {
    handleToggleCart
  };
};
